<template>
    <div style="background-color: white; margin: 1rem 2rem;display: flex;">
      <div class="content-left" style="width: auto;">
        <el-menu default-active="1" class="el-menu-vertical-demo" text-color="#000000">
          <el-menu-item index="1" @click="MenuSelect">
            <i class="el-icon-setting"></i>
            <span>同步酒店</span>
          </el-menu-item>
          <el-menu-item index="2" @click="MenuSelect">
            <i class="el-icon-setting"></i>
            <span>酒店匹配</span>
          </el-menu-item>
          <el-menu-item index="3" @click="MenuSelect">
            <i class="el-icon-setting"></i>
            <span>酒店房型匹配</span>
          </el-menu-item>
          <el-menu-item index="4" @click="MenuSelect">
            <i class="el-icon-setting"></i>
            <span>酒店房型价格导出</span>
          </el-menu-item>
        </el-menu>
      </div>
      <HBESyncHotel v-show="isShow=='1'"></HBESyncHotel>
      <HBEHotelDataSearch v-show="isShow=='2'"></HBEHotelDataSearch>
      <HBEHotelRoomTypesData v-show="isShow=='3'"></HBEHotelRoomTypesData>
      <HBEHotelRoomTypePriceDownload v-show="isShow=='4'"></HBEHotelRoomTypePriceDownload>
    </div>
  </template>
    
<script>
  import HBEHotelDataSearch from "@/views/HBEConfig/HBEHotelDataSearch";
  import HBEHotelRoomTypesData from "@/views/HBEConfig/HBEHotelRoomTypesData";
  import HBESyncHotel from "@/views/HBEConfig/HBESyncHotel";
  import HBEHotelRoomTypePriceDownload from "@/views/HBEConfig/HBEHotelRoomTypePriceDownload";
  export default {
    name: "HBEHotelDataMatching",
    components: {
      HBEHotelDataSearch,
      HBEHotelRoomTypesData,
      HBESyncHotel,
      HBEHotelRoomTypePriceDownload,
    },
    data() {
      return {
        isShow: '1',
      };
    },
    methods: {
      //菜单选择
      MenuSelect(value) {
        let index = value.index;
        this.isShow=index;
      },
    },
  };
</script>
  